import React from "react";
import PropTypes from "prop-types";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { HiAdjustmentsHorizontal } from "react-icons/hi2";
import SearchFilters from "../web-pages/SearchFilters";

const FiltersPanel = ({
  expanded,
  onToggle,
  breadcrumb,
  onClearAll,
  ...filterProps
}) => (
  <div
    className={`filters-panel mb-4${expanded ? " filters-panel--expanded" : ""}`}
  >
    <div
      className="filters-panel__header"
      onClick={onToggle}
      role="button"
      tabIndex={0}
      aria-expanded={expanded}
      aria-label={expanded ? "Collapse filters" : "Expand filters"}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onToggle();
        }
      }}
    >
      <div className="filters-panel__header-left">
        <span className="filters-panel__icon" aria-hidden="true">
          <HiAdjustmentsHorizontal size={20} />
        </span>
        <span className="filters-panel__title">Filters</span>
        {expanded ? (
          <ExpandLess className="filters-panel__chevron" aria-hidden="true" />
        ) : (
          <ExpandMore className="filters-panel__chevron" aria-hidden="true" />
        )}
      </div>

      {breadcrumb ? (
        <div
          className="filters-panel__breadcrumb"
          onClick={(e) => e.stopPropagation()}
        >
          {breadcrumb}
        </div>
      ) : (
        <div className="filters-panel__breadcrumb filters-panel__breadcrumb--empty" />
      )}

      {/* {onClearAll && (
        <button
          type="button"
          className="filters-panel__clear"
          onClick={(e) => {
            e.stopPropagation();
            onClearAll();
          }}
        >
          Clear All
        </button>
      )} */}
    </div>

    {expanded && (
      <div className="filters-panel__body">
        <SearchFilters {...filterProps} />
      </div>
    )}
  </div>
);

FiltersPanel.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  breadcrumb: PropTypes.node,
  onClearAll: PropTypes.func,
};

export default FiltersPanel;
